import log, { injectMiddleWare } from './Logger';
import ConsoleLogger from './ConsoleLogger';
export default log;
injectMiddleWare(ConsoleLogger);
